import { Box } from '@mui/material';

export const CustomTableContainer = ({ children, height = '40em' }) => {
    return (
        <Box
            style={{
                background: '#FFF',
                marginTop: '30px',
                boxShadow: '0px 1px 40px rgba(0, 0, 0, 0.05)',
                borderRadius: '4px',
                paddingLeft: '2em',
                paddingTop: '2em',
                paddingRight: '2em',
                paddingBottom: '2em',
                minHeight: height
            }}>
            {children}
        </Box>
    );
};
